// Calculate fare based on distance and per-km rate
export const calculateFare = (distance, pricePerKm) => {
  const minimumFare = 100;
  const calculatedFare = Math.round(distance * pricePerKm);
  return Math.max(calculatedFare, minimumFare);
};

// Format currency
export const formatCurrency = (amount) => {
  return `₹${Math.round(amount).toLocaleString('en-IN')}`;
};

// Format date to readable format
export const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString('en-IN', options);
};

// Format time
export const formatTime = (timeString) => {
  const options = { hour: '2-digit', minute: '2-digit' };
  return new Date(timeString).toLocaleTimeString('en-IN', options);
};

// Validate mobile number
export const isValidMobileNumber = (mobile) => {
  return /^[0-9]{10}$/.test(mobile);
};

// Validate email
export const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

// Get distance in readable format
export const getDistanceText = (distance) => {
  if (distance < 1) {
    return `${Math.round(distance * 1000)} m`;
  }
  return `${distance.toFixed(1)} km`;
};

// Calculate estimated time
export const getEstimatedTime = (distance) => {
  // Assuming average speed of 30 km/h in city
  const timeInHours = distance / 30;
  const minutes = Math.round(timeInHours * 60);
  
  if (minutes < 60) {
    return `${minutes} mins`;
  }
  
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours}h ${mins}m`;
};

// Get current date in YYYY-MM-DD format
export const getCurrentDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

// Parse booking data for API
export const parseBookingData = (formData) => {
  return {
    tripType: formData.tripType,
    pickupLocation: formData.pickupLocation,
    dropoffLocation: formData.dropoffLocation,
    pickupDate: formData.pickupDate,
    returnDate: formData.tripType === 'roundtrip' ? formData.returnDate : null,
    vehicle: formData.selectedVehicle,
    name: formData.name,
    mobile: formData.mobile,
    adults: parseInt(formData.adults),
    children: parseInt(formData.children) || 0,
    distance: formData.distance,
    totalFare: formData.fare,
    createdAt: new Date().toISOString()
  };
};

const utilsModule = {
  calculateFare,
  formatCurrency,
  formatDate,
  formatTime,
  isValidMobileNumber,
  isValidEmail,
  getDistanceText,
  getEstimatedTime,
  getCurrentDate,
  parseBookingData
};

export default utilsModule;
